/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Downloadopportunitiestemplate3Inputs */

const en_coinvestments_downloadopportunitiestemplate3 = /** @type {(inputs: Coinvestments_Downloadopportunitiestemplate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Opportunities Template`)
};

/**
* | output |
* | --- |
* | "Download Opportunities Template" |
*
* @param {Coinvestments_Downloadopportunitiestemplate3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_downloadopportunitiestemplate3 = /** @type {((inputs?: Coinvestments_Downloadopportunitiestemplate3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Downloadopportunitiestemplate3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_downloadopportunitiestemplate3(inputs)
});
export { coinvestments_downloadopportunitiestemplate3 as "coInvestments_downloadOpportunitiesTemplate" }